import { OldResult } from './type-aliases';
import SettingsCategory = overwolfInternal.settings.enums.SettingsCategory;

// -----------------------------------------------------------------------------
export class OWInternalSettings {
  // ---------------------------------------------------------------------------
  public static async get(category: SettingsCategory): Promise<any> {
    return new Promise((resolve, reject) => {
      overwolfInternal.settings.get(category, result => {
        if (result.status !== 'success') {
          return reject(new Error(result.reason));
        }

        return resolve(result);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static async set(
    category: SettingsCategory,
    setting: any
  ): Promise<OldResult> {
    return new Promise((resolve, reject) => {
      overwolfInternal.settings.set(category, setting, result => {
        if (result.status !== 'success') {
          return reject(new Error(result.reason));
        }

        return resolve(result);
      });
    });
  }
}
